import { useParams } from 'react-router-dom'

export const getSearchParam = (key: string) => new URLSearchParams(window.location.search).get(key) || ''

export const useEventId = () => {
  const {
    eventId,
  } = useParams<{ eventId: string }>()

  return +eventId
}
